/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';
import Nav2 from '../Home/Nav2';
import Footer2 from '../Home/Footer2';
import Faq from './Faq';

import {
  Nav20DataSource,
} from '../Home/data.source';

import '../Home/less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
  }

  render() {
    const children = [
      <Nav2
        id="Nav2_0"
        key="Nav2_0"
        dataSource={Nav20DataSource}
        isMobile={this.state.isMobile}
      />,
      <Faq />,
      <Footer2
        id="Footer2_0"
        key="Footer2_0"
        isMobile={this.state.isMobile}
       />, // 导航和页尾不进入锚点区，如果需要，自行添加;
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      > 
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
      
    );
  }
}
